import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  VisuallyHidden,
} from "@chakra-ui/react";
import { RichText } from "@/components";
import type { FaqEntry } from "@/content";

type FaqProps = {
  entries: readonly FaqEntry[];
  label: string;
};

export const Faq = ({ entries, label }: FaqProps) => (
  <Box as="section" aria-label={label} maxW="maxw" mx="auto" px="pad" pb="sec">
    <VisuallyHidden as="h2">{label}</VisuallyHidden>
    <Accordion allowToggle defaultIndex={[0]} maxW="860px" mx="auto">
      {entries.map((entry) => (
        <AccordionItem key={entry.id} className="print-avoid-break">
          <AccordionButton minH="44px">
            <Box as="span" flex="1" textAlign="left">
              <RichText nodes={entry.question} />
            </Box>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel>
            <RichText nodes={entry.answer} />
          </AccordionPanel>
        </AccordionItem>
      ))}
    </Accordion>
  </Box>
);
